$bog_vmap_app_inspect $mol_page
	source? \
	peers /$mol_tree2
	pack? \https://mol.hyoo.ru
	class_title? \
	title_note \
	editable true
	renamable <= editable
	title <= class_title
	title_content /
		<= Name $mol_string
			hint \имя узла
			enabled <= renamable
			value? <=> title_value? \
			submit? <=> title_submit? null
			event *
				^
				blur? <=> title_submit? null
	base? \
	bases /string
	base_titles *
	Base $mol_select
		hint \класс детали
		enabled <= editable
		value? <=> base?
		options <= bases
		dictionary <= base_titles
		filter_hint \другой класс целиком
		submit? <=> base_submit? null
	tools /$mol_view_content
		<= base_pick null
		<= total \
		<= Note $mol_status
			status <= title_note
	body /$mol_view
		<= Rows $mol_list
			rows <= rows /$mol_view
		<= Shares $mol_expander
			title \Общие значения
			expanded? <=> shares_shown? true
			content <= share_rows /$mol_view
		<= Layout $mol_expander
			title \Раскладка
			expanded? <=> layout_shown? false
			content /
				<= Flex $bog_vmap_app_inspect_flex
					value*? <=> flex_value*? \
					editable <= editable
		<= Inherited $mol_expander
			title \Наследованные
			expanded? <=> inherited_shown? true
			content <= inherited_rows /$mol_view
	cell*? null
	frozen_note \поле заморожено: правка значения сделает его изменяемым
	sub_note \
	Empty $mol_status
		status <= empty_note \Нечего править: в исходнике нет объявления класса
	Node $bog_vmap_lang_node
		source? <=> source?
	Lib $bog_vmap_lib
		pack <= pack
		classes <= classes /
	resettable* false
	reset*? null
	share_able* false
	share_mark* \
	share*? null
	share_unshare*? null
	shares /string
	share_uses* \
	share_value*? $mol_tree2_empty
	Share_row* $mol_form_field
		name <= share_row_name* \
		bids / <= share_uses* \
		control <= Share_value* $bog_vmap_app_inspect_value
			tree? <=> share_value*? $mol_tree2_empty
			binds <= binds
			nodes <= nodes
			editable <= editable
	Row* $bog_vmap_app_inspect_row
		sign <= row_sign* \
		drop_hint <= row_drop_hint* \
		owner <= row_owner* \
		inherited <= row_inherited* false
		value? <=> row_value*? $mol_tree2_empty
		keyed? <=> row_keyed*? false
		changeable? <=> row_changeable*? false
		drop? <=> row_drop*? null
		frozen <= row_frozen* \
		note <= row_note* \
		share_able* <= share_able*
		share_mark* <= share_mark*
		share*? <=> share*?
		share_unshare*? <=> share_unshare*?
		binds <= binds /string
		nodes <= nodes *
		editable <= editable

$bog_vmap_app_inspect_demo $mol_book2
	source? \
	pages /
		<= Source $mol_page
			title \Исходник документа
			tools /
				<= Class_pick $mol_select
					hint \класс
					value? <=> klass? \
					options <= names /string
			body /
				<= Source_text $bog_vmap_app_inspect_value_area
					rows 26
					value? <=> source?
		<= Inspect $bog_vmap_app_inspect
			source? <=> class_source? \
			peers <= trees /$mol_tree2
	Doc $bog_vmap_lang_doc
		source? <=> source?
